import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInventoryAdjustments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.66667 1.33333C3.72115 1.33333 1.33333 3.72115 1.33333 6.66667C1.33333 9.61218 3.72115 12 6.66667 12C9.19412 12 11.3109 10.2419 11.8609 7.88193L11.6046 8.13814C11.3442 8.39845 10.9221 8.39839 10.6618 8.138C10.4015 7.87761 10.4016 7.4555 10.662 7.19519L11.9957 5.86186C12.1207 5.73685 12.2903 5.66664 12.4671 5.66667C12.6439 5.66669 12.8135 5.73696 12.9385 5.862L14.2714 7.19533C14.5318 7.45572 14.5317 7.87783 14.2713 8.13814C14.0109 8.39845 13.5888 8.39839 13.3285 8.138L13.1984 8.00785C12.5777 11.0469 9.88917 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667C0 2.98477 2.98477 0 6.66667 0C9.11334 0 11.2514 1.31839 12.4103 3.28032C12.5976 3.59733 12.4924 4.00613 12.1754 4.19339C11.8584 4.38066 11.4496 4.27548 11.2623 3.95847C10.3333 2.38579 8.62254 1.33333 6.66667 1.33333ZM6.66667 2.66667C7.03486 2.66667 7.33333 2.96514 7.33333 3.33333V6.30988L9.03647 7.4453C9.34282 7.64953 9.4256 8.06345 9.22137 8.3698C9.01713 8.67615 8.60322 8.75893 8.29687 8.5547L6.29687 7.22137C6.1114 7.09772 6 6.88957 6 6.66667V3.33333C6 2.96514 6.29848 2.66667 6.66667 2.66667Z",
		fill: "currentColor"
	})
});
export default SvgInventoryAdjustments;
